import formatNumber from 'helpers/formatNumber';
import { Maths } from 'helpers/maths';
import getLoadUnitAbbreviation from 'screens/YieldV2/LoadDetails/helpers/getLoadUnitAbbreviation';

export default function formatShrink(load, loadUnit, shrinkPercentage) {
  if (load && loadUnit && shrinkPercentage) {
    return formatNumber(
      Maths.multiplyRound(load, shrinkPercentage, 2),
      getLoadUnitAbbreviation(loadUnit),
      2
    );
  }
  return undefined;
}
